import { render } from "./TrainingCalendar.vue?vue&type=template&id=57917350&scoped=true"
import script from "./TrainingCalendar.vue?vue&type=script&lang=js"
export * from "./TrainingCalendar.vue?vue&type=script&lang=js"

import "./TrainingCalendar.vue?vue&type=style&index=0&id=57917350&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57917350"]])

export default __exports__